export default __webpack_public_path__ + "static/media/addIcon.8d0e94d9.svg";